import Box from './Box.js'

/**
 * A flexible space that expands along the major axis of its containing layout.
 * It's useful as a shortcut for filling all the available spaces between elements.
 */

const spacerElement = <Box flexGrow={1} />

export default function Spacer() {
	return spacerElement
}
